import axios from '~/utils/axios';

export interface EndUsersActivityRow {
  metric: string;
  values: Record<string, number>;
  last3Months: number;
}

export interface EndUsersActivityReport {
  timeZone: string;
  generatedAt: string;
  months: string[];
  last3MonthsWindow: string[];
  rows: EndUsersActivityRow[];
}

export interface EndUsersActivityParams {
  from?: string;
  to?: string;
}

export const getEndUsersActivity = (params?: EndUsersActivityParams) => {
  return axios.get<EndUsersActivityReport>('/endUsersActivity', { params });
};

export const exportEndUsersActivity = (
  params: EndUsersActivityParams & { format: 'csv' | 'xlsx' }
) => {
  return axios.get('/endUsersActivity/export', { params, responseType: 'blob' });
};
